import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { noop } from 'lodash';
import ListGrid from 'components/ListGrid';
import ListItem from 'components/ListItem';
import { hideModal, showModal } from 'actions/modal';
import { navigateToAuthPage } from 'actions/app';
import { navigateToPlayerPage } from 'actions/player';
import { hideLoader, showLoader } from 'actions/loader';
import { LIST_ITEMS_SIZE } from 'config';
import useLoadList, { KEY as LIST_QUERY_KEY } from 'hooks/data/useLoadList';
import useOnNavigationBack from 'hooks/useOnNavigationBack';
import { useQueryClient } from 'react-query';

const ListGridContainer = (props) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const { listId } = props.match.params;
  const {
    data,
    isLoading,
    isFetchingNextPage,
    fetchNextPage: loadExtraListItems,
    hasNextPage,
  } = useLoadList(listId, { staleTime: 2 * 60 * 60 * 1000 });
  const isLoaderVisible = isLoading || isFetchingNextPage;

  useEffect(() => {
    dispatch(isLoaderVisible ? showLoader() : hideLoader());
  }, [dispatch, isLoaderVisible]);

  useOnNavigationBack(() => {
    queryClient.resetQueries(LIST_QUERY_KEY);
  });

  if (!data?.content) return null;

  const contentSize = data.content[0].contentType === 'EPG_EVENT' ? 'MEDIUM' : 'LARGE';

  return (
    <ListGrid
      component={ListItem}
      {...props}
      items={data.content}
      title={data.title}
      titles={data.titles}
      itemSize={LIST_ITEMS_SIZE[contentSize]}
      contentSize={contentSize}
      loadExtraListItems={hasNextPage && !isFetchingNextPage ? loadExtraListItems : noop}
    />
  );
};

export const mapDispatchToProps = {
  showModal,
  hideModal,
  navigateToAuthPage,
  navigateToPlayerPage,
};

export default connect(null, mapDispatchToProps)(ListGridContainer);
